import { formatBettingOption, BettingOptionsFormat } from '@betgames/bg-tools';

export const formatSkywardGameMultiplier = (value: number, format: BettingOptionsFormat): string =>
    formatBettingOption({
        value,
        format:
            format === BettingOptionsFormat.HONGKONG
                ? BettingOptionsFormat.HONGKONG
                : BettingOptionsFormat.DECIMAL,
    });
